import { useSelector } from 'react-redux'

import {
  selectActionList,
  selectCancelOfferPreviousDiscount,
  selectCurrentVariantCohort,
  selectHasCancelOffer,
  selectLanguage,
  selectStripeAccountId,
  selectStripeAccountName,
  selectSubscriptionList,
} from 'root-redux/selects/common'
import {
  selectEmail,
  selectUUID,
  selectUserCountryCode,
  selectUserPaymentSystem,
} from 'root-redux/selects/user'

import {
  select3DSecureIframeUrl,
  selectCurrency,
  selectPaymentMethod,
  selectPlanId,
  selectProductId,
  selectSubscription,
  selectSubscriptionBeforeCustomDiscount,
  selectSubscriptionCurrentPriceTax,
  selectSubscriptionDiscountAmount,
  selectSubscriptionFullPrice,
  selectSubscriptionId,
  selectSubscriptionLookupKey,
  selectSubscriptionOldPrice,
  selectSubscriptionPeriodName,
  selectSubscriptionPeriodQuantity,
  selectSubscriptionTrialLookupKey,
  selectSubscriptionTrialOldPrice,
  selectSubscriptionTrialPeriodDays,
  selectSubscriptionTrialPeriodPrice,
  selectSubscriptionTrialPriceTax,
  selectTaxAmount,
} from 'modules/purchase/redux/selects/common'

import { ISubscription } from 'models/subscriptions.model'

import { TimeInterval } from 'root-constants'

import { PaymentMethod, TCardPaymentSystem } from '../constants'

type TReturnsUseStore = {
  uuid: string
  cohort: string
  periodName: TimeInterval | null
  periodQuantity: number
  price: number
  currentPriceTax: number
  trialPriceTax: number
  currency: string
  subscriptions: ISubscription[]
  selectedSubscription: ISubscription | null
  selectedSubscriptionPlanId: number
  threeDSecureIframeUrl: string
  fetchingActionsList: string[]
  hasCancelOffer: boolean
  trialPrice: number
  trialOldPrice: number
  fullOldPrice: number
  productId: string
  email: string
  language: string
  selectedSubscriptionId: string
  taxAmount: number
  trialPeriodDays: number
  stripeAccountId: string
  stripeAccountName: string
  discountAmount: number
  discountPercentage: number
  previousDiscount: number
  priceLookupKey: string
  paymentMethod: PaymentMethod
  paymentSystem: TCardPaymentSystem
  userCountryCode: string
  stripePriceId: string
  trialPriceId: string
}

export const usePurchaseStore = (): TReturnsUseStore => {
  const uuid = useSelector(selectUUID)
  const cohort = useSelector(selectCurrentVariantCohort)
  const language = useSelector(selectLanguage)
  const periodName = useSelector(selectSubscriptionPeriodName)
  const periodQuantity = useSelector(selectSubscriptionPeriodQuantity)
  const price = useSelector(selectSubscriptionFullPrice)
  const currentPriceTax = useSelector(selectSubscriptionCurrentPriceTax)
  const trialPriceTax = useSelector(selectSubscriptionTrialPriceTax)
  const currency = useSelector(selectCurrency)
  const subscriptions = useSelector(selectSubscriptionList)
  const selectedSubscription = useSelector(selectSubscription)
  const selectedSubscriptionId = useSelector(selectSubscriptionId)
  const selectedSubscriptionPlanId = useSelector(selectPlanId)
  const threeDSecureIframeUrl = useSelector(select3DSecureIframeUrl)
  const fetchingActionsList = useSelector(selectActionList)
  const hasCancelOffer = useSelector(selectHasCancelOffer)
  const trialPrice = useSelector(selectSubscriptionTrialPeriodPrice)
  const trialOldPrice = useSelector(selectSubscriptionTrialOldPrice)
  const fullOldPrice = useSelector(selectSubscriptionOldPrice)
  const productId = useSelector(selectProductId)
  const email = useSelector(selectEmail)
  const taxAmount = useSelector(selectTaxAmount)
  const trialPeriodDays = useSelector(selectSubscriptionTrialPeriodDays)
  const stripeAccountId = useSelector(selectStripeAccountId)
  const stripeAccountName = useSelector(selectStripeAccountName)
  const discountAmount = useSelector(selectSubscriptionDiscountAmount)
  const discountPercentage = useSelector(selectSubscriptionBeforeCustomDiscount)
  const previousDiscount = useSelector(selectCancelOfferPreviousDiscount)
  const priceLookupKey = useSelector(selectSubscriptionLookupKey)
  const paymentMethod = useSelector(selectPaymentMethod)
  const paymentSystem = useSelector(selectUserPaymentSystem)
  const userCountryCode = useSelector(selectUserCountryCode)
  const stripePriceId = useSelector(selectSubscriptionLookupKey)
  const trialPriceId = useSelector(selectSubscriptionTrialLookupKey)

  return {
    uuid,
    cohort,
    periodName,
    periodQuantity,
    price,
    currency,
    subscriptions,
    selectedSubscription,
    threeDSecureIframeUrl,
    fetchingActionsList,
    hasCancelOffer,
    trialPrice,
    trialOldPrice,
    fullOldPrice,
    productId,
    email,
    language,
    selectedSubscriptionId,
    selectedSubscriptionPlanId,
    taxAmount,
    trialPeriodDays,
    currentPriceTax,
    trialPriceTax,
    stripeAccountId,
    stripeAccountName,
    discountAmount,
    discountPercentage,
    previousDiscount,
    paymentMethod,
    priceLookupKey,
    paymentSystem,
    userCountryCode,
    stripePriceId,
    trialPriceId,
  }
}
